import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';


import userManagementImage from '../../assets/features/userManagement.png';
import hrmImage from '../../assets/features/hrm.jpg';
import crmImage from '../../assets/features/crm.jpg';
import scmImage from '../../assets/features/scm.jpg';
import frmImage from '../../assets/features/frm.jpg';
import analyticsImage from '../../assets/features/analytics.jpeg';


// Modules Configuration
const modules = [
  {
    id: 'company',
    title: 'Company Management',
    description: 'Streamline company and user management with ease.',
    image: userManagementImage,
    bg: "gray"
  },
  {
    id: 'hrm',
    title: 'Human Resource',
    description: 'Manage employees, payroll, and attendance efficiently.',
    image: hrmImage,
    bg: "yellow-50"
  },
  {
    id: 'crm',
    title: 'Sales & CRM',
    description: 'Optimize sales pipelines and customer relations.',
    image: crmImage
  },
  {
    id: 'scm',
    title: 'Inventory Management',
    description: 'Track stock, orders, and supply chain operations.',
    image: scmImage
  },
  {
    id: 'frm',
    title: 'Finance & Accounting',
    description: 'Monitor expenses and manage financial reports.',
    image: frmImage
  },
  {
    id: 'analytics',
    title: 'Analytics & Reports',
    description: 'Gain insights and generate reports for informed decisions.',
    image: analyticsImage
  },
];

function FeaturesSection() {
  const navigate = useNavigate(); // Navigation hook

  return (
    <section id="features" className="bg-[#0A0F1F] mt-28 text-white py-0">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold mb-6 text-center">
          Explore the Core Features of{' '}
          <span className="text-yellow-400">NIB ERP</span>
        </h2>
        <p className="text-gray-400 max-w-2xl mx-auto mb-12 text-center">
          Streamline your business operations with our modular and scalable ERP system tailored for efficiency.
        </p>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {modules.map((module) => (
            <motion.div
              key={module.id}
              className="relative rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 h-[350px] flex flex-col"
              whileHover={{ scale: 1.05 }}
            >
              {/* Background Image */}
              {/* Image as <img> with object-fit */}
                <img
                  src={module.image}
                  alt={module.title}
                  className="absolute inset-0 w-full h-full object-fill" // Use object-cover for full coverage instead
                  style={{ backgroundColor: module.bg }} // Fallback color
                />

              {/* Overlay */}
              <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-between">
                {/* Title and Description */}
                <div>
                </div>

                {/* Button at the Bottom */}
                <motion.button
                  onClick={() => navigate(`/features/${module.id}`)}
                  className="w-full py-4 px-6 text-left text-white bg-black bg-opacity-60 hover:bg-opacity-60 transition duration-300 flex justify-between items-center"
                  whileHover={{ scale: 1.02 }}
                >
                  <div>
                    <span className="text-lg font-semibold">{module.title}</span>
                    <p className="text-sm text-gray-300"><i>{module.description}</i></p>
                  </div>
                  <span className="text-4xl font-bold text-yellow-400">&gt;</span>
                </motion.button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturesSection;